import { useState, useEffect, useCallback } from 'react';
import { Promocao, ApiPromocaoResponse, PromocaoSelecionada } from '../types/multipatrocinadores';
import { multipatrocinadorService } from '../services/multipatrocinadores';

interface Distributor {
  id: string;
  name: string;
}

interface Type {
  name: string;
}

export const useMultipatrocinadores = () => {
  const [promocoes, setPromocoes] = useState<Promocao[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [types, setTypes] = useState<Type[]>([]);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 50,
    offset: 0,
    count: 0,
  });

  const searchPromocoes = useCallback(async (
    searchTerm: string = '', 
    offset: number = 0, 
    limit: number = 50,
    idDistribuidor: string = '',
    tipo: string = ''
  ) => {
    setLoading(true);
    setError(null);

    try {
      const response = await multipatrocinadorService.searchPromocoes(searchTerm, offset, limit, idDistribuidor, tipo);
      
      if (response.success) {
        setPromocoes(response.data);
        setPagination(response.pagination);
      } else {
        setError('Erro ao buscar promoções');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
      setPromocoes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadFilters = useCallback(async () => {
    setLoadingFilters(true);
    try {
      const [distributorsResponse, typesResponse] = await Promise.all([
        multipatrocinadorService.getDistributors(),
        multipatrocinadorService.getTypes()
      ]);

      if (distributorsResponse.success && distributorsResponse.data.success) {
        const distributorsList = distributorsResponse.data.data
          .map((item: string[]) => ({
            id: item[0],
            name: item[1]
          }))
          .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'));
        setDistributors(distributorsList);
      }

      if (typesResponse.success && typesResponse.data.success) {
        const typesList = typesResponse.data.data.map((item: string[]) => ({
          name: item[0]
        }));
        setTypes(typesList);
      }
    } catch (err) {
      console.error('Erro ao carregar filtros:', err);
    } finally {
      setLoadingFilters(false);
    }
  }, []);
  // Busca inicial
  useEffect(() => {
    searchPromocoes();
    loadFilters();
  }, [searchPromocoes, loadFilters]);

  return {
    promocoes,
    loading,
    error,
    pagination,
    distributors,
    types,
    loadingFilters,
    searchPromocoes,
  };
};